/**
 * Checkbox fields in a written template, named by their label plus nearby text
 * (the table row or paragraph they sit in) so identical labels can be told apart.
 * Used by the field tools ("Show: Only if ☑ … is ticked") and conditional sections.
 */
export interface CheckboxChoice { fieldId: string; name: string }

export function checkboxesIn(doc: any, opts: {
  /** Leave out this field (a checkbox can't depend on itself). */
  excludeId?: string | null;
  /** Only checkboxes ticked by this signer or an earlier one. */
  maxSigner?: number;
  /** Leave out checkboxes inside this document range (a section's own content). */
  excludeRange?: [number, number];
} = {}): CheckboxChoice[] {
  const out: CheckboxChoice[] = [];
  doc.descendants((node: any, pos: number) => {
    if (node.type.name !== 'signatureField' || node.attrs.fieldType !== 'CHECKBOX') return;
    const id = node.attrs.fieldId;
    if (!id || id === opts.excludeId) return;
    if (opts.maxSigner !== undefined && (node.attrs.signerPosition ?? 1) > opts.maxSigner) return;
    if (opts.excludeRange && pos >= opts.excludeRange[0] && pos <= opts.excludeRange[1]) return;
    const $pos = doc.resolve(pos);
    let context = $pos.parent.textContent;
    for (let d = $pos.depth; d > 0; d--) {
      if ($pos.node(d).type.name === 'tableRow') { context = $pos.node(d).textContent; break; }
    }
    context = context.replace(/\s+/g, ' ').trim();
    const label = node.attrs.label || 'Checkbox';
    out.push({ fieldId: id, name: context && context !== label ? `${label} — "${context.slice(0, 40)}${context.length > 40 ? '…' : ''}"` : label });
  });
  return out;
}
